"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockchain = void 0;
const axios_class_1 = require("./axios.class");
class Blockchain {
    async getAddressFromEns(ensName) {
        const { data } = await axios_class_1.axios.get(`/v1/blockchain/getAddressENS/${ensName}`);
        return data;
    }
}
exports.blockchain = new Blockchain();
